/**
 * @generated SignedSource<<f43c40243e8f313befab4e09d28eab46>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "globalVariableId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "globalVariableId",
        "variableName": "globalVariableId"
      }
    ],
    "concreteType": "GlobalVariable",
    "kind": "LinkedField",
    "name": "globalVariable",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "type",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "scope",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "offerId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isUsed",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "teamId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "QGlobalVariableQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "QGlobalVariableQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3962623d4f55ee9d38f9832e7390bc35",
    "id": null,
    "metadata": {},
    "name": "QGlobalVariableQuery",
    "operationKind": "query",
    "text": "query QGlobalVariableQuery(\n  $globalVariableId: ID!\n) {\n  globalVariable(globalVariableId: $globalVariableId) {\n    id\n    name\n    type\n    scope\n    offerId\n    isUsed\n    teamId\n  }\n}\n"
  }
};
})();

node.hash = "123c042ff3b8202e234cc40494501932";

export default node;
